import { defaultColors } from '../../../Common/Services/contexts/ServicesChartsDataContext';
import { Donut } from '../../../Common/Charts/Donut';
import { useCurrentPregnancyChartsDataContext } from './hooks/useCurrentPregnancyChartsDataContext';

export const Method = () => {
    const { chartData } = useCurrentPregnancyChartsDataContext();

    return (
        <Donut
            title={'Método Estimar'}
            subtitles={chartData?.method?.map((item) => item.description)}
            chartData={chartData?.method || []}
            colors={defaultColors.slice(0, chartData?.method?.length) || []}
            height={350}
            className='aligned-container'
        />
    );
};
